import { IComment } from '@app/models/Comment'
import { convertFromMarkup } from '@app/utils/mention'
import { EditorState } from 'draft-js'
import { Record } from 'immutable'

export interface ICommentEditState {
  isPublic: boolean
  markupState: EditorState
}

const CommentEditStateRecord = Record({
  isPublic: false,
  markupState: EditorState.createEmpty(),
})

export class CommentEditState extends CommentEditStateRecord
  implements ICommentEditState {
  public static fromComment(comment: IComment) {
    return new CommentEditState({
      isPublic: comment.isPublic,
      markupState: comment.markup
        ? EditorState.createWithContent(convertFromMarkup(comment.markup))
        : EditorState.createEmpty(),
    })
  }

  public static fromJS(initialState?: Partial<ICommentEditState>) {
    if (!initialState) {
      return new CommentEditState()
    }

    const { markupState, ...rest } = initialState
    return new CommentEditState({
      markupState: markupState ? markupState : EditorState.createEmpty(),
      ...rest,
    })
  }

  public readonly isPublic: boolean
  public readonly markupState: EditorState

  constructor(props?: Partial<CommentEditState>) {
    props ? super(props) : super()
  }
}
